import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';
import UrlDrivenAppDisplay from '../../components/UrlDrivenAppDisplay';
import { useParams, useHistory } from 'react-router-dom';
import NavUtils from '../../NavUtils';
import utils from '../../utils';

function DynamicAppLandingPage({ tenant }) {

     let [ navDescr, setNavDescr ] = useState({});
     let [ appContent, setAppContent ] = useState(null);
     let [ loading, setLoading ] = useState(true);
     let [ loadError, setLoadError ] = useState(false);
     const { user, getAccessTokenSilently } = useAuth0();

    const history = useHistory();

    let userID = user?.sub;

    const getAppContent = async (appType, token) => {
        try {
            let extraParams = 'force_id=' + tenant.tenant.fields.aDGroupID;
            let jsonresponse = await utils.getTenantContent(token, `dynamic/${appType}`, tenant.tenant.fields.tenantslug, userID, extraParams);
            let theAppsContent = {};
            if (jsonresponse.content && Array.isArray(jsonresponse.content) && jsonresponse.content.length > 0) {
                theAppsContent = jsonresponse.content[0];
            } else if (jsonresponse.content && typeof jsonresponse.content === 'object') {
                theAppsContent = jsonresponse.content;
            }
            setAppContent(theAppsContent);
        } catch (error) {
            console.error('Error fetching app content:', error);
        }
    }

    const getAppNavItems = async (appType, token, apiKey) => {
        try {
            let response = await utils.getAppNavItems('get_app_blueprint_b2c', `dynamic/${appType}`, token.accessToken, apiKey, false);
            setNavDescr(response);
        } catch (error) {
            console.error('Error fetching app nav items:', error);
        }
    }

    const getContentAndNav = async (appType) => {
        setLoading(true);
        setLoadError(false);
        try {
            let token = await utils.getAccessToken(getAccessTokenSilently, user);
            let apiKey = await utils.getAPIKey(token);
            await Promise.allSettled([getAppContent(appType, token), getAppNavItems(appType, token, apiKey)]);
        } catch (error) {
            console.error('Error initializing app:', error);
            setLoadError(true);
        } 

        setLoading(false);
    }

    const { appType } = useParams();
    

    let hasAccess = NavUtils.hasAppAccess(tenant, appType);

    if(!hasAccess) {
        history.push('/');
    }

    //get content for this app to deliver to the display
    useEffect( () => {
        
        getContentAndNav(appType);
    // eslint-disable-next-line
    }, []);

    

    return (
        loading?
            <div>Loading...</div>
        :
            loadError?
                <div className="text-center">Unable to load app. Please try again later.</div>
            :
                <UrlDrivenAppDisplay
                    tenant={tenant}
                    content={appContent}
                    navs={navDescr}
                    appType={appType} />

    );
}

export default DynamicAppLandingPage;